import React from 'react';
import styled from 'styled-components';
import { isMobileBreakpoint } from '@zocdoc-frontend-common/utils-deviceutils';
import { MetricsClickable } from '@zocdoc-frontend-common/utils-frontend-metrics';

const SERVICE_PHONE_NUMBER = '855-962-3621';

export function getInvalidMessage({ invalidMessage }) {
    if (invalidMessage) {
        if (
            invalidMessage.includes(SERVICE_PHONE_NUMBER) &&
            isMobileBreakpoint()
        ) {
            const splitMessage = invalidMessage.split(SERVICE_PHONE_NUMBER);

            if (splitMessage.length === 2) {
                return (
                    <p>
                        {splitMessage[0]} <PhoneNumberLink /> {splitMessage[1]}
                    </p>
                );
            } else {
                return invalidMessage;
            }
        } else {
            return invalidMessage;
        }
    }

    return null;
}

export const PhoneNumberLink = () => {
    return (
        <MetricsClickable
            action={'Clicked error message phone number link'}
            element={'PhoneNumberLink'}
        >
            <Link href="tel:8559623621">{SERVICE_PHONE_NUMBER}</Link>
        </MetricsClickable>
    );
};

const Link = styled.a`
    text-decoration: underline;
    cursor: pointer;
`;
